export default "__VITE_ASSET__G5zh5PE9__"